import { PurchaseCard } from 'my-purchases/components/PurchaseCard/PurchaseCard'
import type { Purchase } from 'my-purchases/types/purchaseList'
import styles from './PurchaseList.module.scss'

interface PurchaseListProps {
	readonly purchases: Purchase[]
}

export function PurchaseList({ purchases }: PurchaseListProps) {
	return (
		<ul className={styles.container} data-testid='myPurchases.purchases.list'>
			{purchases.map((purchase) => {
				const { purchaseId } = purchase

				return (
					<li
						key={purchaseId}
						className={styles.card}
						data-testid={`myPurchases.purchases.list.item.${purchaseId}`}
					>
						<PurchaseCard purchase={purchase} />
					</li>
				)
			})}
		</ul>
	)
}
